import { WebApiService } from '../../../../../plugins/webApiService'
import { Events } from '../../../../../plugins/events'
import { SendRequestModel } from '../../../../../plugins/models/SendRequestModel'
import JobFolderBreadcrumbsRequest from '../../../../../scheduler/manager/serverless/i-services/models/job-folders/JobFolderBreadcrumbsRequest';
import JobFolderTreeRequest from '../../../../../scheduler/manager/serverless/i-services/models/job-folders/JobFolderTreeRequest';
import JobFolderCreateRequest from '../../../../../scheduler/manager/serverless/i-services/models/job-folders/JobFolderCreateRequest';
import JobFolderRenameRequest from '../../../../../scheduler/manager/serverless/i-services/models/job-folders/JobFolderRenameRequest';
import JobFolderMoveRequest from '../../../../../scheduler/manager/serverless/i-services/models/job-folders/JobFolderMoveRequest';
import JobFolderDeleteRequest from '../../../../../scheduler/manager/serverless/i-services/models/job-folders/JobFolderDeleteRequest';
import WsResponseModelT from '../../../../../schema-builder/server/models/WsResponseModelT';
import BreadcrumbsJobFolderItem from '../../../../../scheduler/manager/serverless/i-services/models/jobs/BreadcrumbsJobFolderItem';
import JobFolderTreeItem from '../../../../../scheduler/manager/serverless/i-services/models/job-folders/JobFolderTreeItem';

export default class JobFolderWsController {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	GetBreadcrumbsEvent = new Events<WsResponseModelT<Array<BreadcrumbsJobFolderItem>>>();
	GetTreeEvent = new Events<WsResponseModelT<Array<JobFolderTreeItem>>>();
	CreateEvent = new Events<WsResponseModelT<JobFolderTreeItem>>();
	RenameEvent = new Events<WsResponseModelT<JobFolderTreeItem>>();
	MoveEvent = new Events<WsResponseModelT<JobFolderTreeItem>>();
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('JobFolderWsController', 'GetBreadcrumbs', 'SchedulerAdmin', (res: WsResponseModelT<Array<BreadcrumbsJobFolderItem>>) => {
			self.GetBreadcrumbsEvent.trigger(res);
		});
		webApiService.on('JobFolderWsController', 'GetTree', 'SchedulerAdmin', (res: WsResponseModelT<Array<JobFolderTreeItem>>) => {
			self.GetTreeEvent.trigger(res);
		});
		webApiService.on('JobFolderWsController', 'Create', 'SchedulerAdmin', (res: WsResponseModelT<JobFolderTreeItem>) => {
			self.CreateEvent.trigger(res);
		});
		webApiService.on('JobFolderWsController', 'Rename', 'SchedulerAdmin', (res: WsResponseModelT<JobFolderTreeItem>) => {
			self.RenameEvent.trigger(res);
		});
		webApiService.on('JobFolderWsController', 'Move', 'SchedulerAdmin', (res: WsResponseModelT<JobFolderTreeItem>) => {
			self.MoveEvent.trigger(res);
		});
		webApiService.on('JobFolderWsController', 'Delete', 'SchedulerAdmin', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * получить хлебные крошки с папками
	 */
	async GetBreadcrumbs(request: JobFolderBreadcrumbsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobFolderWsController',
			Method: 'GetBreadcrumbs',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить дерево папок
	 */
	async GetTree(request: JobFolderTreeRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobFolderWsController',
			Method: 'GetTree',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание папки
	 */
	async Create(request: JobFolderCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobFolderWsController',
			Method: 'Create',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Переименовать
	 */
	async Rename(request: JobFolderRenameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobFolderWsController',
			Method: 'Rename',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Переместить
	 */
	async Move(request: JobFolderMoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobFolderWsController',
			Method: 'Move',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить
	 */
	async Delete(request: JobFolderDeleteRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobFolderWsController',
			Method: 'Delete',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * получить хлебные крошки с папками
	 */
	async getBreadcrumbsAsync(request: JobFolderBreadcrumbsRequest): Promise<Array<BreadcrumbsJobFolderItem>> {
		return new Promise<Array<BreadcrumbsJobFolderItem>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobFolderWsController',
				Method: 'GetBreadcrumbs',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<BreadcrumbsJobFolderItem>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<BreadcrumbsJobFolderItem>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить дерево папок
	 */
	async getTreeAsync(request: JobFolderTreeRequest): Promise<Array<JobFolderTreeItem>> {
		return new Promise<Array<JobFolderTreeItem>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobFolderWsController',
				Method: 'GetTree',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<JobFolderTreeItem>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<JobFolderTreeItem>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание папки
	 */
	async createAsync(request: JobFolderCreateRequest): Promise<JobFolderTreeItem> {
		return new Promise<JobFolderTreeItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobFolderWsController',
				Method: 'Create',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<JobFolderTreeItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as JobFolderTreeItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Переименовать
	 */
	async renameAsync(request: JobFolderRenameRequest): Promise<JobFolderTreeItem> {
		return new Promise<JobFolderTreeItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobFolderWsController',
				Method: 'Rename',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<JobFolderTreeItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as JobFolderTreeItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Переместить
	 */
	async moveAsync(request: JobFolderMoveRequest): Promise<JobFolderTreeItem> {
		return new Promise<JobFolderTreeItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobFolderWsController',
				Method: 'Move',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<JobFolderTreeItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as JobFolderTreeItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить
	 */
	async deleteAsync(request: JobFolderDeleteRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobFolderWsController',
				Method: 'Delete',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}